import { render, staticRenderFns } from "./SparkrunRecipesTable.vue?vue&type=template&id=b7d56cd8&scoped=true"
import script from "./SparkrunRecipesTable.vue?vue&type=script&lang=ts"
export * from "./SparkrunRecipesTable.vue?vue&type=script&lang=ts"
import style0 from "./SparkrunRecipesTable.vue?vue&type=style&index=0&id=b7d56cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d56cd8",
  null
  
)

export default component.exports